export class OperetionHistoryDTO{
    puid : string;
    operationDateTime : Date;
    tabName : string;
}